export const ROLE_OPTIONS = [
    { value: 'admin', label: 'Admin' },
    { value: 'agents', label: 'Agents' },
    { value: 'attachments', label: 'Attachments' },
    { value: 'claims', label: 'Claims' },
    { value: 'client-impl', label: 'Client Impl' },
    { value: 'client-ops', label: 'Client Ops' },
    { value: 'config', label: 'Config' },
    { value: 'dynamodb', label: 'DynamoDB' },
    { value: 'edi', label: 'Edi' },
    { value: 'finance', label: 'Finance' },
    { value: 'javelina', label: 'javelina' },
    { value: 'job-monitoring', label: 'job-monitoring' },
    { value: 'notifications', label: 'Notifications' },
    { value: 'member-care', label: 'Member-Care' },
    { value: 'members', label: 'Members' },
    { value: 'providers', label: 'Providers' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'stoploss', label: 'Stop Loss' },
    { value: 'support', label: 'Support' },
    { value: 'member_claim_submitted', label: 'Member Claim Submitted' },
];

export const ROLE_LABELS = Object.fromEntries(ROLE_OPTIONS.map((r) => [r.value, r.label]));
